import React from 'react'
import PropTypes from 'prop-types'
import { fonts, BodyLargeRegular, TextButton, AvatarStack, Avatar } from 'prospect-path-base'
import styled from 'styled-components'

const { caption } = fonts
const { medium } = caption

const Container = styled.div`
  display: flex;
  align-items: center;
`

const InviteButton = styled(TextButton)`
  ${medium}
`

const Details = styled.div`
  flex: 1;
`

const AvatarStackContainer = styled.div`
  flex: 1;
`

const Team = ({ title, avatars, ...props }) => (
  <Container {...props}>
    <Details>
      <BodyLargeRegular>{title}</BodyLargeRegular>
      <InviteButton>Invite teammates</InviteButton>
    </Details>
    <AvatarStackContainer>
      <AvatarStack key={avatars} avatars={avatars} />
    </AvatarStackContainer>
  </Container>
)

Team.propTypes = {
  title: PropTypes.string,

}

export default Team
